import { SigiloAutorizacao } from '@app/models/sigilo-autorizacao.model';

import { throwError as observableThrowError, Observable, throwError } from 'rxjs';

import { catchError, tap } from 'rxjs/operators';
import { ProcessoEntrevista } from '@app/models/processo-entrevista';
import { ProcessoObservacao } from '@app/models/processo-observacao';
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpHeaders } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { Processo, UltimasMovimentacoes } from '@app/models/processo.model';
import { TipoMovimentacao, ProcessoMovimentacao } from '@app/models/processo-movimentacao';
import { MeAvise } from '@app/models/me-avise';
import { MinhaAgenda } from '@app/models/minha-agenda';
import { ProcessoDocumento } from '@app/models/processo-documento.model';
import { ProcessoDocumentoPendente } from '@app/models/processo-documento-pendente.model';
import { BuscarProcessosModel } from '@app/pages/processos/buscar-processos/model';
import { UploadFileSasUrl } from '@app/models/upload-file-sas-url';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { FiltrosObterMovimentacoesProcessuais } from '../models/filtro-obter-movimentacoes-processuais.model';
import { MigracaoMovimentacao } from '@app/models/migracao-movimentacao.model';

@Injectable()
export class ProcessoService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }

 gravar(processo: Processo): Observable<any> {
    return this.http.post<any>(this.URL_API + 'processo', processo).pipe(
      catchError((error: any) => observableThrowError(error))
    );
}


  desarquivarProcesso(processoId: number){
    return this.http.post<any>(this.URL_API + 'processo/desarquivar', processoId).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  } 

  assinarContrato(processoId: number, dataAssinatura: string){ 
    let objetoAssinatura = { ProcessoId: processoId, DataAssinatura: dataAssinatura};
    return this.http.post<any>(this.URL_API + 'processo/assinarContrato', objetoAssinatura).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  excluirAssinaturaContrato(processoId: number){ 
    return this.http.post<any>(this.URL_API + 'processo/excluirAssinaturaContrato', processoId).pipe(
      catchError((error: any) => observableThrowError(error)));
  }


  // alterar(processo: Processo) {
  //   return this.http.put(this.URL_API + "processo", processo)
  //     .catch((error: any) => Observable.throw(error.json()));
  // }

  deletar(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `processo/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/${id}`);
  }

  obterTodos(): Observable<any> {
    return this.http.get<any>(this.URL_API + 'processo/');
  }

  // ** */
  verificaArquivamento(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/VerificaArquivamento/${id}`);
  }

  obterResumo(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/ObterResumo/${id}`);
  }

  obterDados(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/obterDados/${id}`);
  }

  obterResumoUltimasMovimentacoes(processoId: number): Observable<UltimasMovimentacoes>{
    return this.http.get<UltimasMovimentacoes>(this.URL_API + `processo/obterResumoMovimentacoes/${processoId}`);
  }

  liberarAcessoSigilo(autorizacao: SigiloAutorizacao){
    return this.http.post<any>(this.URL_API + `processo/liberarSigilo`, autorizacao).pipe(
      catchError((error: any) => observableThrowError(error)));;
  }

  // movimentação
  aplicarSigiloMovimentacao(id: number){
    return this.http.post<any>(this.URL_API + `processo/movimentacao/aplicarSigilo`, id).pipe(
      catchError((error: any) => observableThrowError(error)));;
  }

  desativarSigiloMovimentacao(id: number){
    return this.http.post<any>(this.URL_API + `processo/movimentacao/desativarSigilo`, id).pipe(
      catchError((error: any) => observableThrowError(error)));;
  }

  obterMovimentacaoGeral(tipoMovimentacao: TipoMovimentacao, id: number): Observable<any> {
    let filtro = new FiltrosObterMovimentacoesProcessuais();
    filtro.ProcessoId = id;
    filtro.TipoMovimentacao = tipoMovimentacao;
    return this.http.post<any>(this.URL_API + `processo/movimentacao/obterGeral`, filtro);
  }
  
  obterMovimentacaoPaginada(tipoMovimentacao: TipoMovimentacao, id: number, quantidade: number = 10, pagina: number = 1) : Observable<any> {
    let filtro = new FiltrosObterMovimentacoesProcessuais();
    filtro.ProcessoId = id;
    filtro.TipoMovimentacao = tipoMovimentacao;
    filtro.Pagina = pagina;
    filtro.QuantidadeRegistros = quantidade;
    return this.http.post<any>(this.URL_API + `processo/movimentacao/obterPaginada`, filtro);
  }

  obterMovimentacaoHistorico(tipoMovimentacao: TipoMovimentacao, processoId: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/movimentacao/obterHistorico/${tipoMovimentacao}/${processoId}`);
  }

  obterMovimetnacaoPorId(tipoMovimentacao: TipoMovimentacao, id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/movimentacao/obterPorId/${tipoMovimentacao}/${id}`);
  }

  gravarMovimentacao(processo: ProcessoMovimentacao): Observable<any> {
    processo = this._limparProcesso(processo);
    return this.http.post<any>(this.URL_API + 'processo/movimentacao/gravar', processo).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  migrarMovimentacao(migracao: MigracaoMovimentacao){
    return this.http.post<any>(this.URL_API + 'processo/movimentacao/migrar', migracao).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  private _limparProcesso(processo: ProcessoMovimentacao): ProcessoMovimentacao {
    if (processo.MeAvise[0] && processo.MeAvise[0]?.UsuarioAtualId == null) {
      processo.MeAvise.pop();
    }
    if (processo.Prazo[0] && processo.Prazo[0]?.UsuarioAtualId == null) {
      processo.Prazo.pop();
    }

    return processo;        
  }

  deletarMovimentacao(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `processo/movimentacao/deletar/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  fixarOuDesafixarMovimentacao(id: number): Observable<any> {
    return this.http.post<any>(this.URL_API + `processo/movimentacao/fixarOuDesafixar`, id).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  destacarOuTirarDestaqueMovimentacao(id: number): Observable<any> {
    return this.http.post<any>(this.URL_API + `processo/movimentacao/destaque`, id).pipe(
      catchError((error: any) => observableThrowError(error)));
   }

  resumoOuTirarResumoMovimentacao(id: number): Observable<any> {
    return this.http.post<any>(this.URL_API + `processo/movimentacao/resumo`, id).pipe(
      catchError((error: any) => observableThrowError(error)));
   }

  movimentacaoGravarMeAvise(meAvise: MeAvise): Observable<any> {
    return this.http.post<any>(this.URL_API + `processo/movimentacao/gravarmeavise`, meAvise).pipe(

      catchError((error: any) => observableThrowError(error)));
  }

  movimentacaoObterMeAvise(id: number): Observable<MeAvise> {
    return this.http.get<MeAvise>(this.URL_API + `processo/movimentacao/obterMeAvise/${id}`);
  }

  // movimentacaoObterDescricao(idMovimentacao: number): Observable<any> {
  //   return this.http.get<any>(this.URL_API + `processo/movimentacao/obterDescricao/${idMovimentacao}`);
  // }

  realizarMeAvisePrazo(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/movimentacao/RealizarMeAvisePrazo/?meaviseId=${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  desrealizarMeAvisePrazo(id: number){
    return this.http.post<any>(this.URL_API + 'processo/movimentacao/DesrealizarMeAvisePrazo', id).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  /** Prazo **/

  calculaPrazo(dataVinda: string, dias: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/movimentacao/prazo/calculaprazo/?dataVinda=${dataVinda}&dias=${dias}`);
  }

  /** anexos */
  aplicarSigiloAnexo(id: number){
    return this.http.post<any>(this.URL_API + `processo/anexos/aplicarSigilo`, id).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  desativarSigiloAnexo(id: number){
    return this.http.post<any>(this.URL_API + `processo/anexos/desativarSigilo`, id).pipe(
      catchError((error: any) => observableThrowError(error)));;
  }

  movimentacaoObterArquivo(id: number): Observable<Blob> {
    return this.http.get<Blob>(this.URL_API + `processo/movimentacao/ObterArquivo/${id}`);
  }

  movimentacaoEnviarArquivo(processoId: number, movimentacaoId: number, formData: FormData): Observable<any> {
    return this.http.post<any>(this.URL_API + `processo/movimentacao/enviarArquivo?id=${processoId}&movid=${movimentacaoId}`,
      formData, { headers: { meta: ['upload'] } }
    ).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }


  movimentacaoCopiarDocumento(processoId: number, movimentacaoId: number, formData: FormData): Observable<any> {
    return this.http.post<any>(this.URL_API + `processo/movimentacao/copiarDocumento?id=${processoId}&movid=${movimentacaoId}`,
      formData, { headers: { meta: ['upload'] } }
    ).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  movimentacaoGravarProcessoAnexoRetornandoSas(processoAnexo: ProcessoAnexo): Observable<UploadFileSasUrl> {
    return this.http.post<UploadFileSasUrl>(this.URL_API + `processo/movimentacao/gravar-processo-anexo-retornando-sas`, processoAnexo)
    .pipe(catchError((error: any) => observableThrowError(error)));
  }

  movimentacaoDeletarArquivo(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `processo/movimentacao/deletarArquivo/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }


  /* audiencia */
  gravarAudiencia(minhaAgenda: MinhaAgenda): Observable<any> {
    return this.http.post<any>(this.URL_API + 'processo/audiencia', minhaAgenda).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  deletarAudiencia(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `processo/audiencia/${id}`);
  }

  obterAudienciaPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/audiencia/${id}`);
  }

  obterAudienciaPorProcesso(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/audiencia/ObterPorProcesso/${id}`)
      ;
  }


  /* Arquivo */
  obterArquivosPorProcesso(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/arquivo/ObterPorProcesso/${id}`);
  }

  solicitarArquivo(processoId: number): Observable<any> {
    return this.http.post(this.URL_API + 'processo/arquivo/solicitarArquivo', processoId).pipe(
      catchError((error: any) => observableThrowError(error)));
  }
  encaminharPasta(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/arquivo/encaminharPasta/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  devolverPasta(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/arquivo/devolver/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  cancelarArquivo(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/arquivo/cancelar/${id}`);
  }


  /* anexos */
  obterAnexos(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/anexos/ObterPorProcesso/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  baixarAnexo(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/anexos/baixar/${id}`);
  }

  deletarAnexo(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `processo/anexos/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  /* documentos */
  obterDocumentos(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/documentos/ObterPorProcesso/${id}`).pipe(

      catchError((error: any) => observableThrowError(error)));
  }

  verificaExistenciaArquivoDocumentos(id: number, nomeContainerBlobStorage: string): Observable<boolean> {
    return this.http.get<boolean>(this.URL_API + `processo/documentos/verificar-existencia-arquivo/${id}/${nomeContainerBlobStorage}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  verificaExistenciaArquivoMovimentacao(id: number, nomeContainerBlobStorage: string): Observable<boolean> {
    return this.http.get<boolean>(this.URL_API + `processo/movimentacao/verificar-existencia-arquivo/${id}/${nomeContainerBlobStorage}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterDocumentoPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/documentos/obterPorId/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  baixarDocumento(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/documentos/baixar/${id}`);
  }

  obterSasUrlParaDownloadDocumentos(id: number): Observable<string> {
    return this.http.get<string>(this.URL_API + `processo/documentos/baixar-arquivo/${id}`);
  }

  obterSasUrlParaDownloadMovimentacaoAnexo(id: number): Observable<string> {
    return this.http.get<string>(this.URL_API + `processo/movimentacao/baixar-arquivo/${id}`);
  }

  download(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    })
  }

  // documentos
  gravarDocumento(processoId: number, movimentacaoId: number, formData: FormData): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `processo/documentos/?id=${processoId}&movid=${movimentacaoId}`,
        formData, { headers: { meta: ['upload'] },
        reportProgress: true,
        responseType: 'json'
      }
      ).pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  gravarDocumentoGrande(processoId: number, movimentacaoId: number, formData: FormData): Observable<HttpEvent<any>> {
    var leituraArquivo = new HttpHeaders({
      'meta': ['upload'],
    });

    var requisicaoHttp = new HttpRequest<FormData>('POST', `${this.URL_API}processo/documento-grande/?id=${processoId}&movid=${movimentacaoId}`, formData, {
      headers: leituraArquivo,
      reportProgress: true,
      responseType: 'json',
    });

    return this.http.request(requisicaoHttp);
  }

  atualizarDocumento(processoDocumento: ProcessoDocumento): Observable<any> {
    return this.http.put<any>(this.URL_API + `processo/documentos`, processoDocumento)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  gravarObtendoSas(processoDocumento: ProcessoDocumento, nomeContainerBlobStorage: string): Observable<UploadFileSasUrl>{
    return this.http.post<UploadFileSasUrl>(this.URL_API + `processo/gravar-arquivo-grande-retornando-sas-url/${nomeContainerBlobStorage}`, processoDocumento).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  gravarArquivosPorSasUrl(sasUrl: string, file: File, nomeArquivo: string): Observable<any>{
    const formData = new FormData();
    formData.append('file', file, nomeArquivo);

    return this.http.post(sasUrl, formData, { headers: { meta: ['upload2'] },
    reportProgress: true,
    responseType: 'json'
  }).pipe(catchError((error: any) => observableThrowError(error)));
  }

  deletarDocumento(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `processo/documentos/${id}`)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }


  obterSolicitacoesPorProcesso(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/documentos/solicitacoes/obterPorProcesso/${id}`);
  }

  solicitarDocumento(processoDocumento: ProcessoDocumentoPendente): Observable<any> {
    return this.http.post<any>(this.URL_API + 'processo/documentos/solicitacoes', processoDocumento).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  alterarSolicitacaoDocumento(processoDocumento: ProcessoDocumentoPendente): Observable<any> {
    return this.http.put<any>(this.URL_API + 'processo/documentos/solicitacoes', processoDocumento).pipe(
      catchError((error: any) => observableThrowError(error)));
  }
  deletarSolicitacao(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `processo/documentos/solicitacoes/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  /* atendimento */

  gravarAtendimento(minhaAgenda: MinhaAgenda): Observable<any> {
    return this.http.post<any>(this.URL_API + 'processo/atendimento', minhaAgenda).pipe(
      catchError((error: any) => observableThrowError(error)));
  }


  // **outros */

  ObterInstancias(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/ObterInstancias/${id}`);
  }

  obterPartesDoProcesso(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/obterPartesDoProcesso/${id}`);
  }

  obterBusca(buscarProcessosModel: BuscarProcessosModel): Observable<any> {
    return this.http.post<any>(this.URL_API + `processo/buscar`, buscarProcessosModel);
    //return this.http.post<any>(this.URL_API + `MeiliSearch/criarIndice/processos`, buscarProcessosModel);
    //return this.http.post<any>(this.URL_API + `MeiliSearch/criarIndice/participantes`, buscarProcessosModel);
    //return this.http.post<any>(this.URL_API + `MeiliSearch/criarIndice/anexos`, buscarProcessosModel);

    //return this.http.post<any>(this.URL_API + `processosMeili/configurarCampos`, buscarProcessosModel);
    //return this.http.post<any>(this.URL_API + `participanteMeili/configurarCampos`, buscarProcessosModel);
    //return this.http.post<any>(this.URL_API + `RelatorioAnexoMeili/configurarCampos`, buscarProcessosModel);

    //return this.http.post<any>(this.URL_API + `processosMeili/indexarTodosEmLote`, buscarProcessosModel);
    //return this.http.post<any>(this.URL_API + `participanteMeili/indexarTodosEmLote`, buscarProcessosModel);
    //return this.http.post<any>(this.URL_API + `RelatorioAnexoMeili/indexarTodos`, buscarProcessosModel);

  }

  obterEntrevista(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/entrevista/${id}`);
  }
  atualizarEntrevista(processoEntrevista: ProcessoEntrevista): Observable<any> {
    return this.http.put<any>(this.URL_API + `processo/entrevista/`, processoEntrevista).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterObservacao(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/observacao/${id}`);
  }

  gravarObservacao(processoId: number, observacao: string): Observable<any> {

    const data = {
      ProcessoId: processoId,
      Observacao: observacao,
    };
    return this.http.put<any>(this.URL_API + `processo/observacao`, data).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterMovObservacao(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/movObservacao/${id}`);
  }

  obterProcessosParticipante(participanteId: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `processo/obterProcessosParticipante/${participanteId}`);
  }
  atualizarMovObservacao(processoMovObservacao: ProcessoObservacao): Observable<any> {
    return this.http.put<any>(this.URL_API + `processo/movObservacao/`, processoMovObservacao).pipe(
      catchError((error: any) => observableThrowError(error)));
  }
}
